import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { Location } from '@angular/common';
import * as moment from 'moment';
import { PoliciesService } from 'src/app/providers/policy/policies.service';
import { SeatMgmtService } from 'src/app/providers/seat-management/seat-mgmt.service';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';
import { fromEvent } from 'rxjs';
import {
  map,
  filter,
  debounceTime,
  distinctUntilChanged,
} from 'rxjs/operators';
import { GeneralService } from 'src/app/providers/general/general.service';
declare let $: any;
@Component({
  selector: 'app-workplace-permission',
  templateUrl: './workplace-permission.component.html',
  styleUrls: ['./workplace-permission.component.scss'],
})
export class WorkplacePermissionComponent implements OnInit, AfterViewInit {
  permissionForm: FormGroup;
  response: any;
  empData: any;
  qus: any = [];
  submit = false;
  loading = false;
  visitOffice: any = [];
  attch1: any = [];
  attch2: any = [];
  attch3: any = [];
  isAccepted = false;
  today: any;
  maxDate: any;
  maxTime: any;
  hasCapacity = false;
  capacityMsg = '';
  alrtColor = 'success';
  hasMsg = false;
  seats: any = [];
  result: any = [];
  floor_img: any = '';
  isMtngRoomallw = false;
  fixedSeat: any = false;
  fixedSeatNo: any = false;
  isDesk;
  endTime: any = [];
  searchEmps: any = [];
  visitors: any = [];
  timeSlots = [
    { label: '00:00 am', value: '00:00' },
    { label: '00:30 am', value: '00:30' },
    { label: '01:00 am', value: '01:00' },
    { label: '01:30 am', value: '01:30' },
    { label: '02:00 am', value: '02:00' },
    { label: '02:30 am', value: '02:30' },
    { label: '03:00 am', value: '03:00' },
    { label: '03:30 am', value: '03:30' },
    { label: '04:00 am', value: '04:00' },
    { label: '04:30 am', value: '04:30' },
    { label: '05:00 am', value: '05:00' },
    { label: '05:30 am', value: '05:30' },
    { label: '06:00 am', value: '06:00' },
    { label: '06:30 am', value: '06:30' },
    { label: '07:00 am', value: '07:00' },
    { label: '07:30 am', value: '07:30' },
    { label: '08:00 am', value: '08:00' },
    { label: '08:30 am', value: '08:30' },
    { label: '09:00 am', value: '09:00' },
    { label: '09:30 am', value: '09:30' },
    { label: '10:00 am', value: '10:00' },
    { label: '10:30 am', value: '10:30' },
    { label: '11:00 am', value: '11:00' },
    { label: '11:30 am', value: '11:30' },
    { label: '12:00 pm', value: '12:00' },
    { label: '12:30 pm', value: '12:30' },
    { label: '13:00 pm', value: '13:00' },
    { label: '13:30 pm', value: '13:30' },
    { label: '14:00 pm', value: '14:00' },
    { label: '14:30 pm', value: '14:30' },
    { label: '15:00 pm', value: '15:00' },
    { label: '15:30 pm', value: '15:30' },
    { label: '16:00 pm', value: '16:00' },
    { label: '16:30 pm', value: '16:30' },
    { label: '17:00 pm', value: '17:00' },
    { label: '17:30 pm', value: '17:30' },
    { label: '18:00 pm', value: '18:00' },
    { label: '18:30 pm', value: '18:30' },
    { label: '19:00 pm', value: '19:00' },
    { label: '19:30 pm', value: '19:30' },
    { label: '20:00 pm', value: '20:00' },
    { label: '20:30 pm', value: '20:30' },
    { label: '21:00 pm', value: '21:00' },
    { label: '21:30 pm', value: '21:30' },
    { label: '22:00 pm', value: '22:00' },
    { label: '22:30 pm', value: '22:30' },
    { label: '23:00 pm', value: '23:00' },
    { label: '23:30 pm', value: '23:30' },
  ];

  @ViewChild('itemSearchInput', { static: true }) itemSearchInput: ElementRef;
  constructor(
    private dashboardService: DashboardService,
    private formBuilder: FormBuilder,
    private notifyService: NotificationService,
    private seamServ: SeatMgmtService,
    private location: Location,
    private httpPolicy: PoliciesService,
    private generaServe: GeneralService
  ) {
    this.today = moment().format('YYYY-MM-DD');
    const tmp = moment(this.today);
    this.maxDate = tmp.add(6, 'days').format('YYYY-MM-DD');
  }

  ngOnInit(): void {
    this.permissionFormField();
    this.getLoggedInEmpDetails();
    // this.getQus();
    this.getOffices();
  }

  get f(): any {
    return this.permissionForm.controls;
  }
  get k(): any {
    return this.f.qus as FormArray;
  }
  get start_date_of_visit(): any {
    return this.permissionForm.get('start_date_of_visit').value;
  }
  get end_date_of_visit(): any {
    return this.permissionForm.get('end_date_of_visit').value;
  }
  get in_time_of_visit(): any {
    return this.permissionForm.get('in_time_of_visit').value;
  }
  get visiting_office(): any {
    return this.permissionForm.get('visiting_office').value;
  }
  get selectedSeat(): any {
    return this.permissionForm.get('seat_id').value;
  }
  get mtng_room_id(): any {
    return this.permissionForm.get('mtng_room_id').value;
  }
  get mtng_room_cpcty(): any {
    return this.permissionForm.get('mtng_room_cpcty').value;
  }
  get emp_id(): any {
    return this.permissionForm.get('emp_id').value;
  }

  ngAfterViewInit(): void {
    fromEvent(this.itemSearchInput.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        filter((res) => res.length > 2),
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.searchEmps = [];
        // this.empID = '';
        this.generaServe.getEmps({ key: text }).subscribe((res) => {
          this.searchEmps = res.data;
        });
      });
  }

  selectEmp(event): void {
    const uniq = this.visitors.filter((val) => val.id == event.target.value);
    if (uniq.length > 0) {
      this.notifyService.showError(
        `${uniq[0].username} - ${uniq[0].name} already added!`,
        'Info!'
      );
      return;
    }
    const tmp = this.searchEmps.filter((val) => val.id == event.target.value);
    this.visitors.push(tmp[0]);
    if (
      this.visitors.length + 1 >
      this.permissionForm.get('mtng_room_cpcty').value
    ) {
      this.notifyService.showError(
        'Visitors count can not exceed meeting room capacity',
        'Info!'
      );
      this.visitors.splice(-1);
      return;
    }
  }

  deleteVisitor(data): void {
    this.visitors = this.visitors.filter((val) => val.id != data.id);
  }

  back(): void {
    this.location.back();
  }

  getQus(): void {
    this.dashboardService.covidQues().subscribe((res) => {
      this.qus = res.data;
      this.dynamicForm(this.qus);
    });
  }

  bookDeskModal(modal, id): void {
    this.isDesk = id;
    const params = {
      start_date_of_visit: this.permissionForm.get('start_date_of_visit').value,
      end_date_of_visit: this.permissionForm.get('end_date_of_visit').value,
      in_time_of_visit: this.permissionForm.get('in_time_of_visit').value,
      out_time_of_visit: this.permissionForm.get('out_time_of_visit').value,
      visiting_office: this.permissionForm.get('visiting_office').value,
      scope_id: this.permissionForm.get('visiting_office').value,
      is_mtng_room: this.isDesk,
    };
    this.seamServ.getSeatForBooking(params).subscribe(
      (res) => {
        this.result = res;
        if (this.result.status == true) {
          this.seats = this.result.data;
          this.floor_img = this.result.floor_img;
          $(modal).modal({ backdrop: 'static', keyboard: false });
        } else {
          this.notifyService.showError(this.result.msg);
        }
      },
      (err) => {}
    );
  }

  getOffices(): void {
    this.httpPolicy.workplaceScopeGet().subscribe((res) => {
      this.visitOffice = res.data;
    });
  }

  checkUncheck(event): void {
    this.isAccepted = event.target.checked;
  }
  selectSeat(data): void {
    console.log(data);
    if (data.is_fixed == 1) {
      this.notifyService.showError('This is Fixed Seat For ' + data.fixed);
      return;
    }
    data.isBooked = true;
    if (this.isDesk == 0) {
      this.permissionForm.patchValue({
        seat_id: data.seat_id,
      });
    } else {
      if (
        this.permissionForm.get('mtng_room_cpcty').value != data.mtng_room_cpcty
      ) {
        this.visitors = [];
        this.searchEmps = [];
        this.permissionForm.get('emp_id').reset();
      }

      this.permissionForm.patchValue({
        mtng_room_id: data.seat_id,
        mtng_room_cpcty: data.mtng_room_cpcty,
        mtng_room_capping: data.mtng_room_capping,
      });
    }
    this.seats.forEach((element) => {
      if (element.seat_id !== data.seat_id) {
        element.isBooked = false;
      }
    });

    $('#book_desk').modal('hide');
  }

  checkCapacity(): void {
    if (!this.permissionForm.get('visiting_office').value) {
      this.notifyService.showInfo('Please Select Office', 'Info!');
      return;
    } else if (!this.permissionForm.get('start_date_of_visit').value) {
      this.notifyService.showInfo('select start date', 'Info!');
      return;
    } else if (!this.permissionForm.get('end_date_of_visit').value) {
      this.notifyService.showInfo('select end date', 'Info!');
      return;
    } else if (!this.permissionForm.get('in_time_of_visit').value) {
      this.notifyService.showInfo('select in time', 'Info!');
      return;
    } else if (!this.permissionForm.get('out_time_of_visit').value) {
      this.notifyService.showInfo('select out time', 'Info!');
      return;
    }
    const tempObj = {
      visiting_office: this.permissionForm.get('visiting_office').value,
      start_date_of_visit: this.permissionForm.get('start_date_of_visit').value,
      end_date_of_visit: this.permissionForm.get('end_date_of_visit').value,
      in_time_of_visit:
        this.permissionForm.get('in_time_of_visit').value + ':00',
      out_time_of_visit:
        this.permissionForm.get('out_time_of_visit').value + ':00',
    };
    this.httpPolicy.checkOfficeCapacity(tempObj).subscribe((res) => {
      this.hasMsg = true;
      this.capacityMsg = res.msg;
      if (res.status) {
        if (res.fixed == true) {
          this.fixedSeat = true;
          this.fixedSeatNo = res.seat;
          this.permissionForm.patchValue({
            seat_id: res.seat,
          });
        } else {
          this.permissionForm.patchValue({
            seat_id: '',
          });
          this.fixedSeat = false;
          this.fixedSeatNo = '';
        }
        this.hasCapacity = true;
        this.alrtColor = 'success';
      } else {
        this.alrtColor = 'warning';
        this.hasCapacity = false;
      }
    });
  }

  dynamicForm(qus): void {
    for (let i = 0; i < qus.length; i++) {
      this.k.push(
        this.formBuilder.group({
          optn_id: [''],
          optn_desc: [''],
          optn_respnse: ['', Validators.required],
        })
      );
      //  patch
      (this.k.at(i) as FormGroup).get('optn_id').patchValue(qus[i].value);
      (this.k.at(i) as FormGroup).get('optn_desc').patchValue(qus[i].label);
    }
  }

  permissionFormField(): void {
    this.permissionForm = this.formBuilder.group({
      emp_nm: [''],
      cc: [''],
      desig: [''],
      depart: [''],
      rm: [''],
      mobile: [''],
      mtng_room_cpcty: [''],
      mtng_room_capping: [''],
      visitor_email: [''],
      emp_id: [''],
      user_id: ['', Validators.required],
      age: ['', Validators.required],
      residence_address: ['', Validators.required],
      visiting_office: ['', Validators.required],
      start_date_of_visit: ['', Validators.required],
      end_date_of_visit: ['', Validators.required],
      in_time_of_visit: ['', Validators.required],
      out_time_of_visit: ['', Validators.required],
      hodAttach: [''],
      dose_cert: [''],
      remark: [''],
      seat_id: [''],
      mtng_room_id: [''],
      // qus: new FormArray([]),
    });
  }

  getLoggedInEmpDetails(): void {
    this.dashboardService.getLoggedInEmpDetails().subscribe((res) => {
      this.response = res;
      this.empData = this.response.data;
      this.permissionForm.patchValue({
        emp_nm: this.empData.emp_name,
        cc: this.empData.cc_desc,
        desig: this.empData.desig_desc,
        depart: this.empData.dept_desc,
        rm: this.empData.rm_name,
        mobile: this.empData.mobile,
        user_id: this.empData.id,
      });
    });
  }

  fromDateChange(): void {
    this.hasCapacity = false;
    this.hasMsg = false;
    this.permissionForm.get('seat_id').reset();
    this.permissionForm.get('mtng_room_id').reset();
    this.permissionForm.get('end_date_of_visit').reset();
    this.permissionForm.get('in_time_of_visit').reset();
    this.permissionForm.get('out_time_of_visit').reset();
  }

  endDateChange(): void {
    this.permissionForm.get('seat_id').reset();
    this.permissionForm.get('mtng_room_id').reset();
    this.hasCapacity = false;
    this.hasMsg = false;
    this.permissionForm.get('out_time_of_visit').reset();
    const tmpDiff = moment(
      this.permissionForm.get('end_date_of_visit').value
    ).diff(
      moment(this.permissionForm.get('start_date_of_visit').value),
      'days'
    );
    if (tmpDiff + 1 > 1) {
      this.isMtngRoomallw = false;
    } else {
      this.isMtngRoomallw = true;
    }
  }

  inTimeChange(event): void {
    this.endTime = [];
    this.timeSlots.forEach((val) => {
      if (val.value > event.target.value) {
        this.endTime.push(val);
      }
    });
    this.permissionForm.get('seat_id').reset();
    this.permissionForm.get('mtng_room_id').reset();
    this.permissionForm.get('out_time_of_visit').reset();
    this.hasCapacity = false;
    this.hasMsg = false;
    // const data = event.target.value;
    // const tmpTime = moment(data, 'h:mm:ss A');
    // const maxHours = moment(tmpTime).add(5, 'hours').format('LT');
    // this.maxTime = maxHours;
  }

  changeOffice(): void {
    this.hasCapacity = false;
    this.hasMsg = false;
    this.permissionForm.get('start_date_of_visit').reset();
    this.permissionForm.get('end_date_of_visit').reset();
    this.permissionForm.get('seat_id').reset();
    this.permissionForm.get('mtng_room_id').reset();
  }

  onUploadAttach1(event, id): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (id == 1) {
        this.attch2 = file;
      } else if (id == 2) {
        this.attch3 = file;
      } else if (id == 3) {
        this.attch1 = file;
      }
    }
  }

  reset(): void {
    this.submit = false;
    this.isAccepted = false;
    this.ngOnInit();
  }

  submitPermission(): void {
    this.submit = true;
    if (this.permissionForm.invalid) {
      return;
    }

    if (!this.selectedSeat && !this.mtng_room_id) {
      Swal.fire('Please Select Seat!', '', 'error');
      return;
    }

    if (
      this.visitors.length + 1 <
      this.permissionForm.get('mtng_room_capping').value
    ) {
      Swal.fire(
        `Please enter minimum Employee Id's as per Booking Capacity`,
        '',
        'error'
      );
      return;
    }

    if (this.permissionForm.get('mtng_room_id').value == null) {
      this.permissionForm.patchValue({
        mtng_room_id: 0,
      });
    }
    const tmp = this.permissionForm.value.qus;
    const permissionForm = new FormData();
    permissionForm.append('visitors', JSON.stringify(this.visitors));
    permissionForm.append('qus', JSON.stringify(tmp));
    permissionForm.append('user_id', this.permissionForm.get('user_id').value);
    permissionForm.append('age', this.permissionForm.get('age').value);
    permissionForm.append(
      'visiting_office',
      this.permissionForm.get('visiting_office').value
    );
    permissionForm.append(
      'residence_address',
      this.permissionForm.get('residence_address').value
    );
    permissionForm.append(
      'start_date_of_visit',
      this.permissionForm.get('start_date_of_visit').value
    );
    permissionForm.append(
      'end_date_of_visit',
      this.permissionForm.get('end_date_of_visit').value
    );
    permissionForm.append(
      'in_time_of_visit',
      this.permissionForm.get('in_time_of_visit').value
    );
    permissionForm.append(
      'out_time_of_visit',
      this.permissionForm.get('out_time_of_visit').value
    );
    permissionForm.append('seat_id', this.permissionForm.get('seat_id').value);
    permissionForm.append(
      'mtng_room_id',
      this.permissionForm.get('mtng_room_id').value
    );
    permissionForm.append('attachment1', this.attch1);
    permissionForm.append('hod_attach', this.attch2);
    permissionForm.append('vaccin_attach', this.attch3);
    permissionForm.append('client_url', environment.app_url);
    permissionForm.append('remark', this.permissionForm.get('remark').value);
    permissionForm.append('source', 'Web');
    this.dashboardService.addWorkplacepermissio(permissionForm).subscribe(
      (res) => {
        this.loading = false;
        this.submit = false;
        if (res.status) {
          this.reset();
          this.location.back();
          this.notifyService.showSuccess(res.msg, 'Success!');
        } else {
          this.notifyService.showInfo(res.msg, 'Info!');
        }
      },
      (err) => {
        this.loading = false;
        this.submit = false;
      }
    );
  }
}
